import React, { useEffect, useRef, useState } from 'react'
import { Column } from 'primereact/column'
import IcmsCstService from "./icmsCstService"
import FormList from 'base/FormList'
import { InputSwitch } from 'primereact/inputswitch'

export default function IcmsCstList() {

    const [service] = useState(() => new IcmsCstService())
    const toast = useRef(null)
    const searchData = {
        pkName: 'codigo_icmcst',
        dsName: 'descricao_icmcst',
        mainField: { name: 'descricao_icmcst', label: 'Descrição' },
        advFields: [
            { name: 'codigo_icmcst', label: 'Código', type: 'string', inputMode: 'text' },
            { name: 'codigo_icmcst', label: 'Código', type: 'string', inputMode: 'text' },
            { name: 'descricao_icmcst', label: 'Descrição', type: 'string', inputMode: 'text' },
            { name: 'tem_icms_icmcst', label: 'Tem ICMS', type: 'boolean', component: 'TriStateCheckbox', value: null },
            { name: 'tem_st_icmcst', label: 'Tem ST', type: 'boolean', component: 'TriStateCheckbox', value: null },
            { name: 'tem_antec_st_icmcst', label: 'Tem antecipação ST', type: 'boolean', component: 'TriStateCheckbox', value: null },
            { name: 'tem_redu_bc_icmcst', label: 'Redução BC', type: 'boolean', component: 'TriStateCheckbox', value: null },
            { name: 'tem_isencao_icmcst', label: 'Tem isenção', type: 'boolean', component: 'TriStateCheckbox', value: null },
            { name: 'tem_dir_cred_icmcst', label: 'Dá crédito', type: 'boolean', component: 'TriStateCheckbox', value: null },
            { name: 'tem_difer_icmcst', label: 'Tem diferimento', type: 'boolean', component: 'TriStateCheckbox', value: null },
        ]
    }

    useEffect(() => {
    }, [service])

    return (
        <FormList service={service} toast={toast} searchData={searchData} showActions={true}>
            <Column field="codigo_icmcst" sortable header="Código"></Column>
            <Column field="descricao_icmcst" sortable header="Descrição"></Column>
            <Column field="tem_icms_icmcst" sortable header="Tem ICMS" body={e => <InputSwitch checked={e.tem_icms_icmcst === 1}></InputSwitch>}></Column>
            <Column field="tem_st_icmcst" sortable header="Tem ST" body={e => <InputSwitch checked={e.tem_st_icmcst === 1}></InputSwitch>}></Column>
            <Column field="tem_antec_st_icmcst" sortable header="Tem antecipação ST" body={e => <InputSwitch checked={e.tem_antec_st_icmcst === 1}></InputSwitch>}></Column>
            <Column field="tem_redu_bc_icmcst" sortable header="Tem redução BC" body={e => <InputSwitch checked={e.tem_redu_bc_icmcst === 1}></InputSwitch>}></Column>
            <Column field="tem_isencao_icmcst" sortable header="Tem isenção" body={e => <InputSwitch checked={e.tem_isencao_icmcst === 1}></InputSwitch>}></Column>
            <Column field="tem_dir_cred_icmcst" sortable header="Dá crédito" body={e => <InputSwitch checked={e.tem_dir_cred_icmcst === 1}></InputSwitch>}></Column>
            <Column field="tem_difer_icmcst" sortable header="Tem diferimento" body={e => <InputSwitch checked={e.tem_difer_icmcst === 1}></InputSwitch>}></Column>
        </FormList >
    )
}
